/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import ImgixWithPrioritizedLoading from 'js/components/ImgixWithPrioritizedLoading';

import { Grid, Typography, Typography2, breakpoints } from '@coursera/cds-core';

import { HERO_BANNER_CONTENT_CONTAINER_MAX_WIDTH } from 'bundles/shared-articles/constants';

export type Props = {
  title: string;
  subtitle: string;
  image: {
    src: string;
    alt: string;
  };
  breadCrumbComponent?: React.ReactNode;
};

const styles = {
  bannerContainer: css`
    min-height: 285px;
    max-width: ${HERO_BANNER_CONTENT_CONTAINER_MAX_WIDTH}px;
    margin: 0 auto;
    ${breakpoints.down('md')} {
      max-width: 90%;
    }
    ${breakpoints.down('xs')} {
      min-height: 180px;
    }
  `,
  bannerTitleContainer: css`
    padding-bottom: 20px;
  `,
  title: css`
    margin-bottom: 10px;
  `,
  titleWithoutBreadcrumb: css`
    margin-top: 50px;
    ${breakpoints.down('xs')} {
      margin-top: 30px;
    }
  `,
  subtitle: css`
    max-width: 90%;
    ${breakpoints.down('xs')} {
      max-width: 100%;
    }
  `,
  imageWrapper: css`
    ${breakpoints.down('xs')} {
      display: none;
    }
  `,
};

const ImgParams = {
  quality: 40,
};

const ImageStyle: React.CSSProperties = {
  objectFit: 'contain',
};

const ArticleHubHeroBanner = ({ title, subtitle, image: { src, alt }, breadCrumbComponent }: Props) => (
  <Grid container component="div" css={styles.bannerContainer} justifyContent="space-between">
    <Grid item css={styles.bannerTitleContainer} xs={12} sm={6} md={5}>
      {breadCrumbComponent}
      <Typography
        component="h1"
        variant="d2"
        css={[styles.title, !breadCrumbComponent ? styles.titleWithoutBreadcrumb : '']}
      >
        {title}
      </Typography>
      <Typography2 component="p" variant="bodyPrimary" css={styles.subtitle}>
        {subtitle}
      </Typography2>
    </Grid>
    <Grid item container justifyContent="center" xs={12} sm={6} md={7} css={styles.imageWrapper}>
      <ImgixWithPrioritizedLoading
        imgParams={ImgParams}
        alt={alt}
        src={src}
        maxWidth={300}
        maxHeight={300}
        height={300}
        width={300}
        style={ImageStyle}
      />
    </Grid>
  </Grid>
);

export default ArticleHubHeroBanner;
